export const linkedToTypes = {
  PARTNER: 'PARTNER',
  OPERATION: 'OPERATION',
  TRADING_OFFER: 'TRADING_OFFER',
  TRADING_OFFER_OPERATION: 'TRADING_OFFER_OPERATION',
};
